/**
 * Display names for a visit's recordings: "Recording #2", or "Recording #3 - Mobile" for
 * audio uploaded from the mobile app. Numbering is the recording's position in the visit's
 * `more_audios` list (oldest first), so the web app and the mobile app show the same number.
 *
 * Stored `name`/`filename` values are storage file names (patient name + EHR id + random
 * suffix), so they are never used as the label.
 */

/** True for audio uploaded through the mobile API (`source: "mobile_recorder"`). */
export function isMobileRecording(audio) {
  if (!audio || typeof audio !== "object") return false;
  return audio.source === "mobile_recorder" || /^Mobile Audio Backup\b/.test(audio.name || "");
}

/** "Recording #n", with " - Mobile" for mobile uploads; "Recording" when n is unknown. */
export function recordingLabel(audio, number) {
  const base = typeof number === "number" && number >= 1 ? `Recording #${number}` : "Recording";
  return isMobileRecording(audio) ? `${base} - Mobile` : base;
}
